import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const newsCarousel = new Swiper('.news-carousel', {
   slidesPerView: 1.2,
   spaceBetween: 20,
   slidesOffsetBefore: 12,
   slidesOffsetAfter: 12,
   speed: 700,
   navigation: {
      prevEl: '.news-prev',
      nextEl: '.news-next'
   }
})